"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLegal = exports.updateIdentification = exports.removeUserDataById = exports.initialConfirmEmail = exports.getOptionsData = exports.getMerchantUsers = exports.getIdentificationData = exports.confirmEmail = exports.changeEmail = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _request = _interopRequireDefault(require("@package/request"));

var _utils = require("@package/utils");

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var _dialog = require("@package/dialog");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _profile = require("@widget/profile");

var _slice = require("./slice");

var getMerchantUsers = function getMerchantUsers() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                message: 'Получение данных пользователей'
              });
              dispatch((0, _slice.getUsersRequestAction)());
              _context.next = 5;
              return (0, _request["default"])({
                url: '/users',
                method: 'get'
              });

            case 5:
              result = _context.sent;
              dispatch((0, _slice.getUsersRequestSuccessAction)(result['data']));
              _context.next = 16;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", void 0);

            case 13:
              dispatch((0, _slice.getUsersRequestFailAction)(_context.t0['data']));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при получении данных пользователей'
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getMerchantUsers = getMerchantUsers;

var getOptionsData = function getOptionsData() {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                message: 'Получение данных по команде'
              });
              dispatch((0, _slice.getOptionsRequestAction)());
              _context2.next = 5;
              return (0, _request["default"])({
                url: '/users/current',
                method: 'get'
              });

            case 5:
              result = _context2.sent;
              dispatch((0, _slice.getOptionsRequestSuccessAction)(result['data']));
              _context2.next = 16;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 13;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 13:
              dispatch((0, _slice.getOptionsRequestFailAction)(_context2.t0['data']));
              dispatch(notifications.pushFail(_context2.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при получении данных команды'
              });

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getOptionsData = getOptionsData;

var removeUserDataById = function removeUserDataById(userId) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              (0, _logger.push)({
                message: 'Блокирование пользователя: ' + userId
              });
              dispatch((0, _slice.removeUserRequestAction)());
              _context3.next = 5;
              return (0, _request["default"])({
                url: "/users/".concat(userId),
                method: 'delete'
              });

            case 5:
              result = _context3.sent;
              dispatch((0, _slice.removeUserRequestSuccessAction)(result['data']));
              dispatch(notifications.pushSuccess('Пользователь удален'));
              _context3.next = 17;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);

              if (!(_context3.t0 instanceof _errors.UnauthorizedError)) {
                _context3.next = 14;
                break;
              }

              return _context3.abrupt("return", void 0);

            case 14:
              dispatch((0, _slice.removeUserRequestFailAction)(_context3.t0['data']));
              dispatch(notifications.pushFail(_context3.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при блокировании пользователя: ' + userId
              });

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 10]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.removeUserDataById = removeUserDataById;

var changeEmail = function changeEmail(data) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              (0, _logger.push)({
                message: 'Запрос на изменение емейл пользователя'
              });
              dispatch((0, _slice.changeUserEmailRequestAction)());
              _context4.next = 5;
              return (0, _request["default"])({
                url: '/users/current/emailChange',
                method: 'put',
                data: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, data), {}, {
                  userName: data['email']
                })
              });

            case 5:
              result = _context4.sent;
              dispatch((0, _slice.changeUserEmailRequestSuccessAction)(result['data']));
              dispatch((0, _dialog.closeDialog)('email.change'));
              _context4.next = 17;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);

              if (!(_context4.t0 instanceof _errors.UnauthorizedError)) {
                _context4.next = 14;
                break;
              }

              return _context4.abrupt("return", void 0);

            case 14:
              dispatch((0, _slice.changeUserEmailRequestFailAction)(_context4.t0['data']));
              dispatch(notifications.pushFail(_context4.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при запросе на изменение емайл пользователя'
              });

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 10]]);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.changeEmail = changeEmail;

var initialConfirmEmail = function initialConfirmEmail() {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(dispatch) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              (0, _logger.push)({
                message: 'Запрос данных на подтверждение емайл'
              });
              dispatch((0, _slice.initConfirmEmailDataRequestAction)());
              _context5.next = 5;
              return (0, _request["default"])({
                url: '/users/current/emailConfirmation',
                method: 'post',
                data: {}
              });

            case 5:
              dispatch((0, _slice.initConfirmEmailDataRequestSuccessAction)());
              dispatch((0, _dialog.openDialog)('email.confirm'));
              _context5.next = 16;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);

              if (!(_context5.t0 instanceof _errors.UnauthorizedError)) {
                _context5.next = 13;
                break;
              }

              return _context5.abrupt("return", void 0);

            case 13:
              dispatch((0, _slice.initConfirmEmailDataRequestFailAction)(_context5.t0['data']));

              if (_context5.t0['data']['code'] === '60.6.308') {
                dispatch(notifications.push({
                  title: 'Вы ввели неверный код подтверждения несколько раз',
                  content: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0447\u0435\u0440\u0435\u0437 10 \u043C\u0438\u043D\u0443\u0442 (\u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ".concat(_context5.t0['data']['code'], ")"),
                  mode: 'danger',
                  autoClose: false
                }));
              } else {
                dispatch(notifications.pushFail(_context5.t0['data']));
              }

              (0, _logger.push)({
                message: 'Ошибка при запросе данных на подтверждение емайл'
              });

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 9]]);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.initialConfirmEmail = initialConfirmEmail;

var confirmEmail = function confirmEmail(data) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              (0, _logger.push)({
                message: 'Запрос на подтверждение емайл'
              });
              dispatch((0, _slice.confirmEmailRequestAction)());
              _context6.next = 5;
              return (0, _request["default"])({
                url: '/users/current/emailConfirmation',
                method: 'post',
                data: data
              });

            case 5:
              result = _context6.sent;
              dispatch((0, _slice.confirmEmailRequestSuccessAction)(result));
              dispatch((0, _dialog.closeDialog)('email.confirm'));
              dispatch(notifications.pushSuccess('Email успешно подтверждён'));
              _context6.next = 18;
              break;

            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](0);

              if (!(_context6.t0 instanceof _errors.UnauthorizedError)) {
                _context6.next = 15;
                break;
              }

              return _context6.abrupt("return", void 0);

            case 15:
              dispatch((0, _slice.confirmEmailRequestFailAction)(_context6.t0['data']));

              if (_context6.t0['data']['code'] === '60.6.308') {
                dispatch((0, _dialog.openDialog)('email.exceeded'));
              } else {
                dispatch(notifications.pushFail(_context6.t0['data']));
              }

              (0, _logger.push)({
                message: 'Ошибка при запросе на подтверждение емайл'
              });

            case 18:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 11]]);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};

exports.confirmEmail = confirmEmail;

var getIdentificationData = function getIdentificationData(merchantId) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              (0, _logger.push)({
                message: 'Запрос на получение данных идентификации'
              });
              dispatch((0, _slice.getIdentificationDataRequestAction)());
              _context7.next = 5;
              return (0, _request["default"])({
                url: "/v2/merchants/".concat(merchantId, "/identification"),
                method: 'get'
              });

            case 5:
              result = _context7.sent;
              dispatch((0, _slice.getIdentificationDataRequestSuccessAction)(result['data']));
              _context7.next = 16;
              break;

            case 9:
              _context7.prev = 9;
              _context7.t0 = _context7["catch"](0);

              if (!(_context7.t0 instanceof _errors.UnauthorizedError)) {
                _context7.next = 13;
                break;
              }

              return _context7.abrupt("return", void 0);

            case 13:
              dispatch((0, _slice.getIdentificationDataRequestFailAction)());
              dispatch(notifications.pushFail(_context7.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при запросе данных идентификации'
              });

            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 9]]);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};

exports.getIdentificationData = getIdentificationData;

var updateIdentification = function updateIdentification(merchantId) {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8(dispatch) {
      var newData, count, notExit, _yield$request, data;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              (0, _logger.push)({
                message: 'Запрос на изменения уровня идентификации'
              });
              dispatch((0, _slice.updateIdentificationDataRequestAction)());
              _context8.next = 5;
              return (0, _request["default"])({
                url: "/v2/merchants/".concat(merchantId, "/identification"),
                method: 'post',
                data: {}
              });

            case 5:
              newData = null;
              count = 0;
              notExit = true;

            case 8:
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Опрос созданной идентификации для мерчанта с id: ' + merchantId
              });
              ++count;
              _context8.next = 12;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 12:
              _context8.next = 14;
              return (0, _request["default"])({
                url: "/v2/merchants/".concat(merchantId, "/identification"),
                method: 'get'
              });

            case 14:
              _yield$request = _context8.sent;
              data = _yield$request.data;

              if (data && data['lastAttempt']) {
                if (!!data['lastAttempt']['paymentLink']) {
                  notExit = false;
                  newData = data;
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context8.next = 19;
                break;
              }

              throw {
                data: {
                  code: '1.1.1',
                  message: 'Превышено время ожидания'
                }
              };

            case 19:
              if (notExit) {
                _context8.next = 8;
                break;
              }

            case 20:
              dispatch((0, _slice.updateIdentificationDataRequestSuccessAction)(newData));

              if (newData['lastAttempt']['paymentLink']) {
                window.open(newData['lastAttempt']['paymentLink']);
              }

              _context8.next = 31;
              break;

            case 24:
              _context8.prev = 24;
              _context8.t0 = _context8["catch"](0);

              if (!(_context8.t0 instanceof _errors.UnauthorizedError)) {
                _context8.next = 28;
                break;
              }

              return _context8.abrupt("return", void 0);

            case 28:
              dispatch((0, _slice.updateIdentificationDataRequestFailAction)());
              dispatch(notifications.pushFail(_context8.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при запросе на изменения уровня идентификации'
              });

            case 31:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 24]]);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.updateIdentification = updateIdentification;

var updateLegal = function updateLegal(data) {
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              (0, _logger.push)({
                message: "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 #".concat(data.id)
              });
              dispatch((0, _slice.updateLegalRequestAction)());
              _context9.next = 5;
              return (0, _request["default"])({
                url: '/profiles/update',
                method: 'PUT',
                data: data
              });

            case 5:
              result = _context9.sent;
              dispatch((0, _slice.updateLegalRequestSuccessAction)());
              _context9.next = 9;
              return dispatch((0, _profile.getProfile)());

            case 9:
              dispatch(notifications.pushSuccess('ИНН организации успешно обновлён'));
              _context9.next = 17;
              break;

            case 12:
              _context9.prev = 12;
              _context9.t0 = _context9["catch"](0);
              dispatch((0, _slice.updateLegalRequestFailAction)());
              dispatch(notifications.pushFail(_context9.t0.data));
              (0, _logger.push)({
                message: 'Ошибка при обновлении мерчанта'
              });

            case 17:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 12]]);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};

exports.updateLegal = updateLegal;